import React, {Component} from 'react';
const { connect } = require('react-redux');
import queryString from 'query-string';

import 'sass/buyxxl.scss';

import HeaderXXL from 'components/XXL/HeaderXXL';

import LoginRedirect from '../components/LoginRedirect';
import XXLFunctionsText from '../components/XXL/XXLFunctionsText';

import PaymentOptionRadio from 'components/payment/PaymentOptionRadio';
import PaymentForm from '../components/payment/PaymentForm';

import {t, dt} from 'l10n';

import {paymentMembership} from 'backend-helpers/payment';
import {getProfile} from 'reducers/buyXXL';
import {getCurrentUser} from 'reducers/currentUser';

class BuyXXL extends Component {
    constructor(props) {
        super(props);

        this.state = {
            t: 'xxl60',
            returnPath: '/'
        };

        this.onSuccess = this.onSuccess.bind(this);
    }

    componentDidMount() {
        this.loadDependentData(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.loadDependentData(nextProps)
    }

    loadDependentData(props) {
        let {location, user, getProfile} = props;

        let {r: id, return_path} = queryString.parse(location.search);
        if (id && (!user || user.id != id)) {
            getProfile({id});
        }

        if (return_path) {
            this.setState({returnPath: return_path});
        }
    }

    onSuccess() {
        let {getCurrentUser} = this.props;

        getCurrentUser();
    }

    render() {
        let {currentUser, location, user} = this.props;

        if (!currentUser.isLoggedIn()) {
            return <LoginRedirect location={location}/>
        }

        let {t, message, returnPath} = this.state;

        let paymentFormAdditionalData = {t, message};
        if (user) paymentFormAdditionalData.r = user.id;

        const paymentPlans = [
            {value: 'xxl60', name: dt('xxl', '%1 days', 60), price: 25, freePoints: 0},
            {value: 'xxl180', name: dt('xxl', '%1 days', 180), price: 60, freePoints: 0},
            {value: 'xxl365', name: dt('xxl', '%1 days', 365), price: 100, freePoints: 0}
        ];

        return (
            <div id="wrapper">
                <HeaderXXL>
                    {user ? dt('xxl', 'Give XXL membership') : dt('xxl', 'Buy XXL Membership')}
                </HeaderXXL>

                <aside className="buy-xxl">
                    <div className="content">

                        <h2 dangerouslySetInnerHTML={{__html:
                            user ?
                                dt('xxl', 'Choose what XXL plan you\'ll give to <strong>%1</strong>', user.nick) :
                                dt('xxl', 'Choose your XXL plan')
                        }}/>

                        <div className="form-buy-xxl">

                            <div className="payment-options">
                                {paymentPlans.map((plan, index) =>
                                    <PaymentOptionRadio
                                        value={plan.value}
                                        name={plan.name}
                                        price={plan.price}
                                        freePoints={plan.freePoints}
                                        checked={t === plan.value ? 'checked' : null}
                                        onSelect={(value) => this.setState({t: value})}
                                        key={index}
                                    />
                                )}
                            </div>

                            {!user && <XXLFunctionsFoldable/>}

                            {user &&
                            <div className="message-block">
                                <p>{dt('xxl', 'You can attach a message to %1, if you want:', user.nick)}</p>
                                <textarea name="message" onChange={(e) => this.setState({message: e.target.value})}/>
                            </div>
                            }

                            <div className="help-text-block">
                                <p className="help-text" dangerouslySetInnerHTML={{__html: dt('xxl', 'Single payment, <em>without automated renewal</em>. You will be charged <strong>only</strong> once.')}}/>
                            </div>

                            <PaymentForm
                                currentUser={currentUser}
                                backendFn={paymentMembership}
                                additionalData={paymentFormAdditionalData}
                                onSuccess={this.onSuccess}
                                returnPath={returnPath}
                            />
                        </div>

                    </div>
                </aside>

            </div>
        )
    }
}


class XXLFunctionsFoldable extends Component {
    constructor(props) {
        super(props);

        this.state = {expanded: false}
    }

    render() {
        let {expanded} = this.state;

        return (
            <div className={'fonctionsXXL' + (expanded ? ' expanded' : '')}>
                <div className="controls" onClick={() => this.setState({expanded: !expanded})}>
                    <p>{dt('xxl', 'More information about Functions XXL')}</p>
                    <a className="toggle">
                        {expanded ? '−' : '+'}
                    </a>
                </div>
                <aside className="block-fonctions-xxl">
                    <XXLFunctionsText className="text" showLink={false}/>
                </aside>
            </div>
        )
    }
}

export default connect(
    state => ({
        currentUser: state.currentUser,
        user: state.buyXXL.user
    }), ({
        getProfile: getProfile,
        getCurrentUser: getCurrentUser
    })
)(BuyXXL)


// WEBPACK FOOTER //
// ./src/containers/BuyXXL.js